import { TableRow, TableCell, ListItemText, Typography, IconButton, Grid, TableBody, TableHead, MenuItem, Menu, TableContainer, Link, ListItem, Icon, Button, Dialog, DialogContent, DialogTitle, DialogActions, CircularProgress } from "@material-ui/core";
import { Cancel, CancelOutlined, Edit, GetApp, MoreHoriz, RemoveCircleOutline, Replay, Timer, CheckCircleOutline, ErrorOutline, Cached, People, Settings, PlayArrow, ToggleOn, ToggleOff } from "@material-ui/icons";
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import React, { useEffect, useState, useRef } from "react";
import { Collapse, Table, Tooltip } from "react-bootstrap";
import clsx from 'clsx';
import { CancelBatch, CancelBatchConsole, getBatchOrders, DownloadAllResults, materialRevisionItemsExists, GetBatchParameters, createBatchParameters, checkIfCompareExists } from "./RestService";
import { useMsal } from "@azure/msal-react";
import CustomStatusIcon from "./CustomStatusIcon";
import { GridWindow } from "@material-ui/data-grid";
import { useSnackbar } from "react-simple-snackbar";
import { successSnackbarOptions, errorSnackbarOptions, warningSnackbarOptions } from "./SnackbarOptions";
import { ConvertedTimeString, GetEmpty, LoadParameters } from "./Common";
import config from "../config";
import ModalPopup from './ModalPopup';
import LinearProgress from '@material-ui/core/LinearProgress';


export default function BatchRow(props) {
    const [currentSelection, setCurrentSelection] = useState(props.currentSelection);
    const [orders, setOrders] = useState(null);
    const [orderElements, setCurrentOrderElements] = useState(null);
    const [selected, setSelected] = useState(false);
    const [lock, setLock] = useState(false);
    const [mainKey, setMainKey] = useState(1);
    const [openSuccessSnackbar, closeSuccessSnackbar] = useSnackbar(successSnackbarOptions());
    const [openErrorSnackbar, closeErrorSnackbar] = useSnackbar(errorSnackbarOptions());
    const [openWarningSnackbar, closeWarningSnackbar] = useSnackbar(warningSnackbarOptions());
    const { instance, accounts } = useMsal();
    const classes = props.classes;
    const globalClasses = props.globalClasses;
    const index3 = props.index;
    const [b, setB] = useState(props.batch == null ? null : props.batch);
    const d = props.material;
    const shareObj = props.shareObj;
    const [errorPopupOpen, setErrorPopupOpen] = useState(false); 
    const [popupMessage, setPopupMessage] = useState('');
    const [circularProgressOpen, setCircularProgressOpen] = useState(false);
    const [progress, setProgress] = useState(0);
    
    const GetRunningNum = (orderName) => {
        let splitName = orderName.split("-");
        if (splitName.length >= 2) {   
            return splitName[splitName.length - 2].slice(-4);
        }
        else {
            return orderName.slice(-4);
        }
    };

    const handleDownloadClick = async (event, clickedOrder, clickedBatch) => {
        
        const downloadAction = () => {
            props.setAnchorElDownload(event.currentTarget);
            props.setClickedOrder(clickedOrder);
            props.setSelectedBatch(clickedBatch);
        } 
        props.checkPDMLoginAndRun(downloadAction);
    };


    const getSuccessRate = (batch) => {
        //console.log("batch: ", batch);
        let successRate = "0.00%"
        let successOrders = 0;
        let failureOrders = 0;
        if (batch["orders"].length > 0) {
            batch["orders"].forEach(order => {
              if (order["status"]?.toLowerCase() === "failed")
                failureOrders = failureOrders + 1
              else if (order["status"]?.toLowerCase() === "job completed")
                successOrders = successOrders + 1                           
            });
            successRate = (successOrders/batch["executeOrders"].length*100.0).toFixed(2).toString() + "%"
        }
        return successRate;
    }

    const generateOrderElements = (clickedBatch) => {
        let tempOrders = [];
        let orderElements = [];
        
        if (clickedBatch["orders"].length > 0) {
            for (let oIndex = 0; oIndex < clickedBatch["orders"].length; oIndex++) {
                tempOrders.push(clickedBatch["orders"][oIndex]);
            }
        }
        tempOrders.sort((a,b) => parseInt(GetRunningNum(a["name"]), 10) - parseInt(GetRunningNum(b["name"]), 10));
        setOrders(tempOrders);

        const rawValue = clickedBatch?.executeArguments?.cws_error_recording; // string
        const errorstatusIsset = rawValue === "true"; // boolean
        
        if(tempOrders.length) {
            for (let index = 0; index < tempOrders.length; index++) {
                const element = tempOrders[index];
                    //console.log("ELEMENT: ", element);
                    let desc = "";
                    let caD_duration = "";
                    let caD_loops = "";
                    
                    if (element["description"])
                    {
                        desc = element["description"];
                    }
                    if (element["caD_duration"] != "not available")
                    {
                        caD_duration = element["caD_duration"];
                    }
                    if (element["caD_loops"] != "not available")
                    {
                        caD_loops = element["caD_loops"];
                    }
                    
                    let statusIcon = (<CustomStatusIcon status={"Not run"}></CustomStatusIcon>)
                    if (element["status"])
                    {
                    if (element.status?.toLowerCase() === "processing")
                        statusIcon = (<CustomStatusIcon status={"Processing"}></CustomStatusIcon>)
                    else if (element.status?.toLowerCase() === "failed" || element.status?.toLowerCase() === "pdm import error")
                        statusIcon = (<CustomStatusIcon status={"Failed"}></CustomStatusIcon>)
                    else if (element.status?.toLowerCase() === "cancelled")
                        statusIcon = (<CustomStatusIcon status={"Cancelled"}></CustomStatusIcon>)
                    else if (["job completed", "completed"].includes(element.status?.toLowerCase()))
                        statusIcon = (<CustomStatusIcon status={"Success"}></CustomStatusIcon>) 
                    }

                    const statusMap = {
                        "Processing": "Processing",
                        "FAILED": "Failed",
                        "JOB COMPLETED": "Success",
                    };

                    const statusLookup = !errorstatusIsset
                        ? "Not run"
                        : element?.status?.toLowerCase() === "pdm import error"
                            ? "FAILED"
                            : statusMap[element?.status] || "Not run";
 

                    const errorstatusIcon = <Tooltip title={statusLookup}><CustomStatusIcon status={statusLookup}  /></Tooltip>;
                    
                    let pdmUrl = config.pdmUrl+"#!object?obj_id=test_case:";
                    let pdmConfUrl = config.pdmUrl+"#!object?obj_id=item:";
                    
                    orderElements.push(
                        <TableRow key={"orders_data_" + (index) + "_" + element["name"] + mainKey} className={classes.orderRow} style={{background:"white"}}>
                            
                            <TableCell className={classes.newbatchCell} align="center" colSpan={2}>
                                <Table className={classes.tableres} style={{display:"block"}}>
                                    <TableRow style={{width:"100%", display:"flex"}}>
                                        <TableCell className={classes.newbatchCell} style={{textAlign: "center", width: "10%", fontSize: "smaller", borderBottom: "0px solid", marginLeft: "13%", margin: "auto"}} align="right">
                                        </TableCell>
                                        <TableCell className={classes.newbatchCell} align="left" style={{fontSize: "smaller", width: "70%", borderBottom: "0px solid", paddingTop: "1%", paddingBottom: "1%"}}>
                                        <ListItem style={{ textAlign: "left"}}>
                                            <ListItemText
                                                style={{ overflow: "ellipsis"}}
                                                disableTypography
                                                primary={
                                                element["status"] != "Not run" && element["status"] != "Processing" ?
                                                <Typography style={{ margin: "0",textOverflow: "clip", wordBreak: "break-word", whiteSpace: "normal", width: "100%"}} className={globalClasses.smallFont}><Link target="_blank" href={pdmUrl + element["name"]}>{element["name"]}</Link></Typography>
                                                :
                                                <Typography style={{ margin: "0",textOverflow: "clip", wordBreak: "break-word", whiteSpace: "normal", width: "100%"}} className={globalClasses.smallFont}>{element["name"]}</Typography>
                                            }
                                                secondary={<Tooltip title={desc}><Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)", whiteSpace: "pre-line"}}>{desc.length > 46 ? desc.slice(0, 43) + "..." : desc}</Typography> </Tooltip>
                                                } 
                                            />
                                        
                                        </ListItem>
                                        </TableCell>
                                        <TableCell className={classes.newbatchCell} style={{textAlign: "center", fontSize: "smaller", width:"20%", borderBottom: "0px solid", marginLeft: "13%", margin: "auto"}} align="center">
                                        {
                                            element["configurationId"] != null   
                                            ?  
                                            element["configurationId"] != ""
                                            ?
                                            element["configurationId"] != "not available"
                                            ?
                                            <Tooltip title={"Link to configuration"}>
                                            <IconButton className={globalClasses.customButton} aria-controls="simple-menu" aria-haspopup="true" onClick={(e) => window.open(pdmConfUrl + element["configurationId"], '_blank')}>
                                                <Settings />
                                            </IconButton>
                                            </Tooltip>
                                            :
                                            <></>
                                            :
                                            <></>
                                            : 
                                            <></>
                                        }
                                        </TableCell>
                                    </TableRow>
                                </Table>
                            </TableCell>
                            <TableCell className={classes.newbatchCell} align="center" onClick={element.status?.toLowerCase() === "failed" ? () => handleOpenErrorPopup(b,element) : null} style={{ cursor: element.status?.toLowerCase() === "failed" ? 'pointer' : 'default' }}>
                                <Tooltip title={element["status"]}>
                                    {statusIcon}
                                    {/* <RemoveCircleOutline className={classes.NotRunIcon} /> */}
                                </Tooltip>
                            </TableCell>

                            <TableCell className={classes.newbatchCell} align="center">

                            </TableCell>
                            <TableCell className={classes.newbatchCell} align="center">
                                {
                                    GetEmpty(element["configurationId"]) == false &&
                                    element["configurationId"] != "" &&
                                    element["configurationId"] != "not available"
                                    ?
                                    <IconButton
                                        disabled={false}
                                        className={globalClasses.customButton}
                                        aria-controls="simple-menu"
                                        align="left"
                                        aria-haspopup="true"
                                        onClick={(e) => {
                                            // if (isBatchDownloadBlocked) {
                                            //     e.stopPropagation();
                                            //     return;
                                            // }

                                            handleDownloadClick(e, element, clickedBatch);
                                        }}
                                    >
                                        <GetApp />
                                    </IconButton>
                                    :
                                    <IconButton
                                        disabled={true}
                                        className={globalClasses.customButton}
                                        aria-controls="simple-menu"
                                        align="left"
                                        aria-haspopup="true"
                                    >
                                        <GetApp />
                                    </IconButton>   
                                }
                            </TableCell>
                            <TableCell className={classes.newbatchCell} align="center" onClick={statusLookup != "Not run" && element.status?.toLowerCase() === "failed" ? () => handleOpenErrorPopup(b,element) : null} style={{ cursor: element.status?.toLowerCase() === "failed" ? 'pointer' : 'default' }}>
                                {errorstatusIcon} 
                            </TableCell>
                            <TableCell className={classes.newbatchCell} align="right" colSpan={1} style={{paddingRight: "50px", fontSize: "smaller", fontWeight: "bold", paddingTop: "1%", paddingBottom: "1%"}}>
                            
                            </TableCell>
                            <TableCell className={classes.newbatchCell} align="center" colSpan={6}>
                                <TableRow  style={{width:"100%", display:"flex"}}>
                                    <TableCell className={classes.orderCell} align="center" style={{fontSize: "smaller", width: "50%"}}>
                                        <Tooltip title={"Cad Duration"} placement="bottom-start">
                                        <Grid container direction="row" alignItems="center" spacing={1} justifyContent="center">
                                            <Timer fontSize='small' />
                                            <Typography style={{paddingLeft: "4px"}}> {caD_duration}</Typography>
                                        </Grid>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell className={classes.orderCell} style={{paddingRight: "8px", fontSize: "smaller", width:"50%", paddingTop: "2%"}} align="right">
                                        <Tooltip title={"Cad Loops"} placement="bottom-start">
                                        <Grid container direction="row" alignItems="center" spacing={1} justifyContent="center">
                                            <Replay fontSize='small' />
                                            <Typography style={{paddingLeft: "4px"}}> {caD_loops}</Typography>
                                        </Grid>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            </TableCell>
                        </TableRow>
                        );    
            }
        } else {
            orderElements.push(
                <TableRow className={classes.orderRow} style={{background:"white", height:"50px"}}>
                    <TableCell className={classes.newbatchCell} align="center" colSpan={13}>
                        No test orders found.
                    </TableCell> 
                </TableRow>
            );
        } 
        
        setCurrentOrderElements(orderElements);
    };

    const handleBatchClick = async (index, clickedBatch) => {
        console.log("clickedBatch: ", clickedBatch);
        await LoadParameters(instance, clickedBatch);
        setSelected(!selected);
        if (orderElements == null)
        {
            generateOrderElements(clickedBatch);
        }
        props.handleBatchClick(index, clickedBatch);
    }

    const handleEditClick = (e, clickedBatch, kmID, kmRev, clickedOrders) => {
        //console.log(clickedBatch);
        console.log("clickedBatch: ", clickedBatch);
        console.log("kmID: ", kmID);
        console.log("kmRev: ", kmRev);
        console.log("clickedOrders: ", clickedOrders);
        props.handleEditClick(e, clickedBatch, kmID, kmRev, clickedOrders)
    };

    const handleErrorClick = (b, element) => {
        const errors = GetOrderErrorModeErrors(b, element)[0];
        console.log("errorsStr: ", errors);
        props.handleSetErrorModeDialog(errors);
    }
    
    const handleOpenErrorPopup = (b, element) => {
        setPopupMessage(element["popupMsgStatus"]);
        setErrorPopupOpen(true);
    };

     const handleCloseErrorPopup = () => {
        setErrorPopupOpen(false);
    };

    const getExpectedDownloadTypes = (batch) => {
        const args = batch?.executeArguments || {};

        const confPDM = args.confPDM === true || args.confPDM === "true";
        const sendToCAD = args.sendToCAD === true || args.sendToCAD === "true";
        const deepCheck = args.levelOfScan === "deep_check";
        const saveTrace = args.saveTrace === true || args.saveTrace === "true";
        const downloadMFG = args.downloadMFG === true || args.downloadMFG === "true";

        let resultTypes = [];

        if (confPDM) {
            resultTypes.push("PDMORDERXML");
        }

        if (confPDM && sendToCAD) {
            resultTypes.push("XML");
            resultTypes.push("LOG");
            resultTypes.push("PDM");
        }

        if (confPDM && sendToCAD && deepCheck) {
            resultTypes.push("MCLOG");
        }

        if (confPDM && sendToCAD && downloadMFG) {
            resultTypes.push("MFG");
        }

        if (confPDM && deepCheck && saveTrace) {
            resultTypes.push("TRACE");
        }

        return resultTypes;
    };

    const hasAnyAvailableDownloadItem = (batch) => {
        if (!batch || !Array.isArray(batch.orders))
            return false;

        const expectedTypes = getExpectedDownloadTypes(batch);

        if (expectedTypes.length === 0)
            return false;

        return batch.orders.some(order => {
            if (
                order.status === "Processing" ||
                !order.configurationId ||
                order.configurationId === "not available"
            ) {
                return false;
            }

            return expectedTypes.some(type => {
                // PDMORDERXML can be generated by backend even if not available yet.
                if (type === "PDMORDERXML") {
                    return true;
                }

                return props.downloadAvailability?.[`${order.configurationId}_${type}`] === true;
            });
        });
    };

    const hasValidDownloadableExecutedOrder = (batch) => {
        if (!batch || !Array.isArray(batch.orders))
            return false;

        return batch.orders.some(order => {
            const orderStatus = String(order.status || "").toLowerCase();

            return (
                (
                    orderStatus === "job completed" ||
                    orderStatus === "completed" ||
                    orderStatus === "success" ||
                    orderStatus === "failed" ||
                    orderStatus === "processing" ||
                    orderStatus === "cancelled" ||
                    orderStatus === "pdm import error"
                ) &&
                order.configurationId &&
                order.configurationId !== "" &&
                order.configurationId !== "not available"
            );
        });
    };

    const shouldDisableDownloadAll = (batch) => {
        if (!batch)
            return true;

        const status = String(batch.status || "").toLowerCase();

        const allowedBatchStatus =
            status === "success" ||
            status === "partialfailed" ||
            status === "failed" ||
            status === "not run" ||
            status === "processing" ||
            status === "cancelled" ||
            status === "cancel" ||
            status === "pdm import error";

        if (!allowedBatchStatus) {
            return true;
        }

        if (
            status === "processing" ||
            status === "cancelled" ||
            status === "cancel"
        ) {
            return !hasValidDownloadableExecutedOrder(batch);
        }

        if (props.batchDownloadAvailable?.[batch.id] === true) {
            return false;
        }

        const args = batch.executeArguments || {};

        const confPDM = args.confPDM === true || args.confPDM === "true";
        const cws_error_recording = args.cws_error_recording === true || args.cws_error_recording === "true";
        const cws_skipmode = args.cws_skipmode === true || args.cws_skipmode === "true";
        const sendToCAD = args.sendToCAD === true || args.sendToCAD === "true";
        const deepCheck = args.levelOfScan === "deep_check";
        const downloadMFG = args.downloadMFG === true || args.downloadMFG === "true";

        const hasAnyCompletedOrder =
            Array.isArray(batch.orders) &&
            batch.orders.some(order =>
                String(order.status || "").toLowerCase() === "job completed" &&
                order.configurationId &&
                order.configurationId !== "not available"
            );

        const hasAnyFailedOrder =
            Array.isArray(batch.orders) &&
            batch.orders.some(order =>
                String(order.status || "").toLowerCase() === "failed" &&
                order.configurationId &&
                order.configurationId !== "not available"
            );

        const hasAnyProcessingOrder =
            Array.isArray(batch.orders) &&
            batch.orders.some(order =>
                String(order.status || "").toLowerCase() === "processing" &&
                order.configurationId &&
                order.configurationId !== "" &&
                order.configurationId !== "not available"
            );

        const hasAnySavedNotRunOrder =
            Array.isArray(batch.orders) &&
            batch.orders.some(order =>
                String(order.status || "").toLowerCase() === "not run"
            );

        const hasAnyDownloadableOrder =
            Array.isArray(batch.orders) &&
            batch.orders.some(order => {
                const orderStatus = String(order.status || "").toLowerCase();

                return (
                    orderStatus !== "processing" &&
                    orderStatus !== "cancelled" &&
                    orderStatus !== "cancel" &&
                    order.configurationId &&
                    order.configurationId !== "not available"
                );
            });

        const hasAnyExecutedOrder = hasAnyCompletedOrder || hasAnyFailedOrder;
        

        if ((cws_error_recording || cws_skipmode) && hasAnyProcessingOrder) {
            return false;
        }

        if (
            confPDM &&
            !sendToCAD &&
            !deepCheck &&
            !downloadMFG
        ) {
            return !(hasAnyCompletedOrder || hasAnyFailedOrder || (hasAnySavedNotRunOrder && hasAnyExecutedOrder));
        }

        return !hasAnyDownloadableOrder;
    };

    const getStoredCompareName = (configurationId) => {
        const key = `compareName_${configurationId}`;
        return localStorage.getItem(key);
    };

    const hasProcessingOrders = (batch) => {
        if (!batch || !Array.isArray(batch.orders))
            return false;

        return batch.orders.some(order => {
            const orderStatus = String(order.status || "").toLowerCase();

            return (
                orderStatus === "processing" ||
                orderStatus === "inprogress"
            );
        });
    };

    const isBatchStillRunningForDownload = (batch) => {
        if (!batch)
            return false;

        const batchStatus = String(batch.status || "").toLowerCase();

        if (
            batchStatus === "processing" ||
            batchStatus === "inprogress"
        ) {
            return true;
        }

        if (!Array.isArray(batch.orders))
            return false;

        return batch.orders.some(order => {
            const orderStatus = String(order.status || "").toLowerCase();

            return (
                orderStatus === "processing" ||
                orderStatus === "inprogress"
            );
        });
    };

    const handleBatchDownloadClick = async (b, event) => {
        event?.currentTarget?.blur(); 
        await LoadParameters(instance, b);
        const downloadAction = () => {
            let tempBatch = b;
            let tmpOrders = [];
            let tmpOrderNames = [];

            if (!GetEmpty(tempBatch["orders"])) {
                tempBatch["orders"].forEach(element => {
                    const orderStatus = String(element["status"] || "").toLowerCase();

                    if (
                        (
                            orderStatus === "job completed" ||
                            orderStatus === "completed" ||
                            orderStatus === "success" ||
                            orderStatus === "failed" ||
                            orderStatus === "processing" ||
                            orderStatus === "cancelled" ||
                            orderStatus === "pdm import error"
                        ) &&
                        element["configurationId"] &&
                        element["configurationId"] !== "not available"
                    ) {
                        tmpOrders.push(element["configurationId"]);
                        tmpOrderNames.push(element["name"]);
                    }
                });
            }

            if (tmpOrders.length === 0) {
                alert("There are no test orders results found for this batch");
                return;
            }

            const isMidRunDownload = isBatchStillRunningForDownload(tempBatch);

            if (isMidRunDownload) {
                const continueDownload = window.confirm(
                    "This batch is still running.\n\n" +
                    "Waiting for the batch to complete is recommended before using Download All.\n\n" +
                    "If you continue now, the ZIP will contain only the result files available at this moment.\n\n" +
                    "Do you still want to continue?"
                );

                if (!continueDownload) {
                    sessionStorage.setItem("circularProgress", "false");
                    sessionStorage.setItem("downloadProgress", "0");
                    setProgress(0);
                    setCircularProgressOpen(false);
                    return;
                }
            }

            let batchName = tempBatch["name"];
            let batchOrderListsName = tmpOrders.map(String).join(",");

            sessionStorage.setItem("circularProgress", "true");
            sessionStorage.setItem("downloadProgress", "0");
            setProgress(0);
            setCircularProgressOpen(true);
            let compareMap = {};

            if (tempBatch["executeArguments"]["levelOfScan"] === "deep_check") {

                tempBatch.configurationList.forEach(config => {
                    let configID = config.name;
                    let compareName = getStoredCompareName(configID);

                    // console.log(
                    //     `Config: ${configID}, Stored Compare Name:`,
                    //     compareName
                    // );

                    if (compareName) {
                        compareMap[configID] = compareName;
                    }
                });
            } else {
                console.log("Deep check NOT enabled ? skipping compare lookup");
            }
            
            Object.values(compareMap).forEach(compareName => {
                checkIfCompareExists(instance, "Compare", compareName);
            });

            const compareMapJson = JSON.stringify(compareMap);

            DownloadAllResults(
                instance,
                batchName,
                batchOrderListsName,
                tmpOrderNames.join(','),
                "DWN",
                accounts[0].username,
                compareMapJson,
                isMidRunDownload ? "partial" : "final"
            );
        };

        props.checkPDMLoginAndRun(downloadAction);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            const val = sessionStorage.getItem("downloadProgress");
            if (val !== null) {
                setProgress(Number(val));
            }
        }, 300);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            let circularProgress = sessionStorage.getItem("circularProgress");
			if(circularProgress=="false")
			{
				setCircularProgressOpen(false);
                if(document.getElementById("CirProg"))
                {
                    document.getElementById("CirProg").style.display="none";
                }
			}
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const CancelButton = async (clickedBatch) => {
        setLock(true);
        console.log("clickedBatch: ", clickedBatch);
        await LoadParameters(instance, clickedBatch);
        let message = "";
        let answer = window.confirm("Are you sure you want to cancel the run?");
        if (answer == true)
        {
            let regex = new RegExp("(?:" + clickedBatch["executeOrders"].join("|") + ")$");
            clickedBatch["orders"].forEach(order => {
                if (order["name"].match(regex)) {
                    order["status"] = "Cancelled";
                order["configurationid"] = "not available";
                order["cad_duration"] = "not available";
                order["cad_loops"] = "not available";
                order["mc_color"] = "not available";
                order["popupmsgstatus"] = "not available";
                }
            });
            RefreshOrders();
            const cancelBatchResult = await CancelBatch(instance, clickedBatch["id"], clickedBatch["orders"]);
            if (cancelBatchResult["exception"])
            {
                openWarningSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{cancelBatchResult["exception"]}</p></div>,300000)
                setLock(false);
            }            
            else
            {
                const parameterData = await createBatchParameters(instance, clickedBatch["id"], clickedBatch["orders"], clickedBatch["defaultCharacteristics"]);
                    if(parameterData && parameterData.exception) {
                        setLock(false);
                        openWarningSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{"Failed to update order cancel information to S3."}</p></div>,300000);
                    }
                    else
                    {
              openSuccessSnackbar(<div style={{whiteSpace: "nowrap"}}><SuccessIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{"Batch execute stopped."}</p></div>,300000);
              clickedBatch["status"] = "Cancelled";
              props.handleCancelClick(clickedBatch);
              props.setReRender(!props.reRender);
            }

            }
            const cancelBatchConsoleResult = await CancelBatchConsole(instance, accounts[0].username, clickedBatch["name"],clickedBatch["lastRun"]);
            setLock(false);
            if (cancelBatchConsoleResult == "Failed") {
                openWarningSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{"Console side failed to cancel batch."}</p></div>,300000)
            }  
        }
    };

    const RefreshOrders = () => {
        generateOrderElements(b);
    }

    useEffect(() => {
        setB(props.batch);
        setMainKey(mainKey + 1);
        RefreshOrders();
    }, [props.batch, props.reRender]);

    useEffect(() => {
        //RefreshOrders();
    }, [b]);

    useEffect(() => {
        if (props.batch) {
            setB(props.batch);
            
            if (selected && props.batch["orders"]) {
                generateOrderElements(props.batch);
            }
        }
    }, [props.batch, selected]);

    const GetErrorMode = (tmpBatch) => {
        //let modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
        //let modeIcon = <RemoveCircleOutline className={globalClasses.NotRunIcon} />
        let modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
        if (tmpBatch) {   
            if (tmpBatch["executeArguments"])
            {
                if (tmpBatch["executeArguments"]["cws_error_recording"])
                {
                    if (tmpBatch["executeArguments"]["cws_error_recording"] == "true")
                    {
                        //modeIcon = <ToggleOn className={globalClasses.successIcon} />
                        //modeIcon = <CheckCircleOutline className={globalClasses.successIcon} />
                        modeIcon = <Icon style={{backgroundColor: "#4BB543", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>On</Icon>
                    }   
                    else
                    {
                        //modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
                        //modeIcon = <RemoveCircleOutline className={globalClasses.NotRunIcon} />
                        modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
                    }
                }
            }
        }
        return modeIcon;
    };

    const GetErrorModeStatus = (tmpBatch) => {
        let modeStatus = "Off";
        if (tmpBatch) {   
            if (tmpBatch["executeArguments"])
            {
                if (tmpBatch["executeArguments"]["cws_error_recording"])
                {
                    if (tmpBatch["executeArguments"]["cws_error_recording"] == "true")
                    {
                        modeStatus = "On";
                    }   
                    else
                    {
                        modeStatus = "Off";
                    }
                }
            }
        }
        return modeStatus;
    };

    const GetSkipMode = (tmpBatch) => {
        //let modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
        let modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
        if (tmpBatch) {   
            if (tmpBatch["executeArguments"])
            {
                if (tmpBatch["executeArguments"]["cws_testing_skip_objects"])
                {
                    if (tmpBatch["executeArguments"]["cws_testing_skip_objects"] != "")
                    {
                        //modeIcon = <ToggleOn className={globalClasses.successIcon} />
                        modeIcon = <Icon style={{backgroundColor: "#4BB543", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>On</Icon>
                    }   
                    else
                    {
                        //modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
                        modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
                    }
                }
            }
        }
        return modeIcon;
    };

    const GetSkipModeStatus = (tmpBatch) => {
        let modeStatus = "Off";
        if (tmpBatch) {   
            if (tmpBatch["executeArguments"])
            {
                if (tmpBatch["executeArguments"]["cws_testing_skip_objects"])
                {
                    if (tmpBatch["executeArguments"]["cws_testing_skip_objects"] != "")
                    {
                        modeStatus = "On";
                    }   
                    else
                    {
                        modeStatus = "Off";
                    }
                }
            }
        }
        return modeStatus;
    };

    const GetOrderErrorMode = (tmpBatch, currentOrder) => {
        //let modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
        let modeIcon = <RemoveCircleOutline className={globalClasses.NotRunIcon} />
        //let modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
        // console.log("BATCH: ", tmpBatch);
        // console.log("currentOrder: ", currentOrder);
        
        let checkErrorModes = true;
        if (tmpBatch["errorModeStatus"])
        {
            if (tmpBatch["errorModeStatus"].toLowerCase() == "processing")
            {
                checkErrorModes = false;
                let foundExecOrder = false;
                if (tmpBatch["executeOrders"])
                {
                    if (tmpBatch["executeOrders"].length > 0)
                    {
                        tmpBatch["executeOrders"].forEach(element => {
                            if (currentOrder["name"].endsWith(element))
                            {
                                modeIcon = <Cached className={globalClasses.inProgressIcon} />
                                foundExecOrder = true;
                            }
                        });
                    }   
                }
            }
        }
        else
        {
            checkErrorModes = false;
        }
        if (props.batchesErrorModes != null && checkErrorModes == true)
        {
            // console.log("props.batchesErrorModes: ", props.batchesErrorModes);
            if (props.batchesErrorModes.length > 0)
            {
                let findBatch = props.batchesErrorModes.find(x => x.batchID == tmpBatch["id"]);
                if (findBatch)
                {
                    let findOrder = findBatch["errorModeOrders"].find(tmpOrder => tmpOrder.name == currentOrder.name);
                    if (findOrder)
                    {
                        modeIcon = <ErrorIcon className={globalClasses.errorIcon} />
                    }
                    else
                    {
                        let foundExecOrder = false;
                        if (tmpBatch["executeOrders"])
                        {
                            if (tmpBatch["executeOrders"].length > 0)
                            {
                                tmpBatch["executeOrders"].forEach(element => {
                                    if (currentOrder["name"].endsWith(element))
                                    {
                                        modeIcon = <SuccessIcon className={globalClasses.successIcon} />
                                    }
                                });
                            }   
                        }
                        
                    }
                }
            }
        }
        return modeIcon;
    };

    const GetOrderErrorModeStatus = (tmpBatch, currentOrder) => {
        //let modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
        let modeStatus = "Unavailable";
        //let modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
        // console.log("BATCH: ", tmpBatch);
        // console.log("currentOrder: ", currentOrder);
        
        let checkErrorModes = true;
        if (tmpBatch["errorModeStatus"])
        {
            if (tmpBatch["errorModeStatus"].toLowerCase() == "processing")
            {
                checkErrorModes = false;
                let foundExecOrder = false;
                if (tmpBatch["executeOrders"])
                {
                    if (tmpBatch["executeOrders"].length > 0)
                    {
                        tmpBatch["executeOrders"].forEach(element => {
                            if (currentOrder["name"].endsWith(element))
                            {
                                modeStatus = "Processing"
                                foundExecOrder = true;
                            }
                        });
                    }   
                }
            }
        }
        else
        {
            checkErrorModes = false;
        }
        if (props.batchesErrorModes != null && checkErrorModes == true)
        {
            // console.log("props.batchesErrorModes: ", props.batchesErrorModes);
            if (props.batchesErrorModes.length > 0)
            {
                let findBatch = props.batchesErrorModes.find(x => x.batchID == tmpBatch["id"]);
                if (findBatch)
                {
                    let findOrder = findBatch["errorModeOrders"].find(tmpOrder => tmpOrder.name == currentOrder.name);
                    if (findOrder)
                    {
                        modeStatus = "Errors";
                    }
                    else
                    {
                        let foundExecOrder = false;
                        if (tmpBatch["executeOrders"])
                        {
                            if (tmpBatch["executeOrders"].length > 0)
                            {
                                tmpBatch["executeOrders"].forEach(element => {
                                    if (currentOrder["name"].endsWith(element))
                                    {
                                        modeStatus = "Success";
                                    }
                                });
                            }   
                        }
                        
                    }
                }
            }
        }
        return modeStatus;
    };

    const GetOrderErrorModeErrors = (tmpBatch, currentOrder) => {
        //let modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
        let errors = [];
        //let modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
        
        let checkErrorModes = true;
        if (tmpBatch["errorModeStatus"])
        {
            if (tmpBatch["errorModeStatus"].toLowerCase() == "processing")
            {
                checkErrorModes = false;
            }
        }
        else
        {
            checkErrorModes = false;
        }
        if (props.batchesErrorModes != null && checkErrorModes == true)
        {
            //console.log("props.batchesErrorModes: ", props.batchesErrorModes);
            if (props.batchesErrorModes.length > 0)
            {
                let findBatch = props.batchesErrorModes.find(x => x.batchID == tmpBatch["id"]);
                if (findBatch)
                {
                    let findOrder = findBatch["errorModeOrders"].find(tmpOrder => tmpOrder.name == currentOrder.name);
                    if (findOrder)
                    {
                        errors.push(findOrder["errors"]);
                    }
                }
            }
        }
        return errors;
    };

    const bvorders = b.orders ?? [];

    const hasOrders = bvorders.length > 0;

    const statusLower = (b.status ?? "").toLowerCase();

    const tbstatuses = bvorders.map(
        order => order?.status?.toLowerCase()
    );

    const isBatchDownloadBlocked =
        statusLower === "processing" ||
        statusLower === "inprogress" ||
        statusLower === "cancel" ||
        statusLower === "cancelled";

        const hasCompletedOrders = hasOrders && bvorders.some(
            order => order?.status === "JOB COMPLETED"
        );
      
    const tbhasFailedOrders = tbstatuses.includes("failed");
    const tbhasCompletedOrdersInList = tbstatuses.includes("job completed");
    
    // Treat mixed success + failed as partial success
    const hasPartialSuccess = tbhasFailedOrders && tbhasCompletedOrdersInList;
    
    const tballOrdersFailed = hasOrders && tbstatuses.every(status => status === "failed");
    
    let isdownloadAllDisabled = hasOrders 
    ? tballOrdersFailed || hasPartialSuccess || !hasCompletedOrders
    : !["partialfailed", "success"].includes(statusLower);

    return (
        <React.Fragment key={b["key"] + "_main" + mainKey}>
        <TableRow key={b["key"]} className={clsx({
            [classes.activeBatch]: selected,
            [classes.batchDataRow]: true
        })}>
            <TableCell className={classes.newbatchCell} align="right" onClick={() => handleBatchClick(index3, b)}>
                {
                    b["status"] != "Processing" && props.sharedToMe == false &&
                    ((b.batchSize ?? 0) > 0 || (b.orders?.length ?? 0) > 0 || (b.executeOrders?.length ?? 0) > 0)
                    ?
                    <Tooltip title="Execute batch">
                    <IconButton className={clsx(globalClasses.customButton, globalClasses.blueColor)} onClick={(e)=>{
                        props.handleBatchExecuteOpenClick(e, b);
                        e.stopPropagation();
                    }}>
                        <PlayArrow />
                    </IconButton>
                    </Tooltip>
                :  
                <></>    
                }
                
            </TableCell>
            <TableCell className={classes.newbatchCell} style={{paddingLeft: "5px"}} align="left" onClick={() => handleBatchClick(index3, b)}>
                <ListItemText
                    style={{ margin: "0"}}
                    
                    disableTypography
                    primary={<Typography style={{ margin: "0",textOverflow: "clip", wordBreak: "break-word", whiteSpace: "normal", width: "100%"}} className={clsx({
                        [classes.activeBatchText]: selected,
                        [globalClasses.smallFont]: true
                    })}>{b["name"] + ", " + (b["description"] == null ? " " : b["description"])}</Typography>}
                    secondary={<Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)", whiteSpace: "pre-line"}}>{props.orderSecondaryText}</Typography> 
                }
                />
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center" onClick={() => handleBatchClick(index3, b)}>
                <Tooltip title={b["status"]}>
                    {props.statusIcon}
                </Tooltip>
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center">
                <Typography className={globalClasses.smallFont} onClick={() => handleBatchClick(index3, b)}>{b["material"] + "/" + b["materialRevision"]}</Typography>
                {
                    b["pdmDescription"] === undefined ? <></> : <Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)", whiteSpace: "pre-line"}} onClick={() => handleBatchClick(index3, b)}>{b["pdmDescription"]}</Typography>
                }
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center">
            {
                b["status"].toLowerCase() == "partialfailed" ||
                b["status"].toLowerCase() == "success" ||
                b["status"].toLowerCase() == "not run" ||
                b["status"].toLowerCase() == "failed" ||
                b["status"].toLowerCase() == "pdm import error" ||  
                (
                    (
                        b["status"].toLowerCase() == "processing" ||
                        b["status"].toLowerCase() == "cancelled" ||
                        b["status"].toLowerCase() == "cancel"
                    ) &&
                    hasValidDownloadableExecutedOrder(b)
                )
                ?
                <Tooltip title={"Download results for the entire batch"}>
                    <IconButton
                        disabled={shouldDisableDownloadAll(b)}
                        className={globalClasses.customButton}
                        style={{ textAlign: "center" }}
                        onClick={(e) => handleBatchDownloadClick(b, e)}
                    >
                        <GetApp />
                    </IconButton>
                </Tooltip>
                :
                <IconButton
                    disabled={true}
                    className={globalClasses.customButton}
                    style={{ textAlign: "center" }}
                    onClick={(e) => handleBatchDownloadClick(b, e)}
                >
                    <GetApp />
                </IconButton>
            }
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center">
                <Tooltip title={GetErrorModeStatus(b)}>
                    {GetErrorMode(b)}
                </Tooltip>
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center" onClick={() => handleBatchClick(index3, b)}>
                <Tooltip title={GetSkipModeStatus(b)}>
                    {GetSkipMode(b)}
                </Tooltip>
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center" onClick={() => handleBatchClick(index3, b)}>
                <ListItemText
                    style={{ margin: "0"}}
                    disableTypography
                    primary={<Typography className={globalClasses.smallFont}>{b["status"] == "Not run" ? " " : b["executeOrders"] === undefined ? " " : b["executeOrders"] == null ? " " : b["executeOrders"].length == 0 ? " " : getSuccessRate(b)}</Typography>}
                    secondary={<Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)"}}>{b["lastRunBy"] == null ? " " : ConvertedTimeString(props.lastRun)}</Typography> 
                }
                />
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center" onClick={() => handleBatchClick(index3, b)}>
            <Typography>{b["executeOrders"] === undefined ? " ": b["executeOrders"] == null ? " " : b["executeOrders"].length}</Typography>
                
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center" onClick={() => handleBatchClick(index3, b)}>
            <Typography className={globalClasses.smallFont}>{b["batchSize"] !== undefined ? b["batchSize"] : (b["orders"] ? b["orders"].length : 0)}</Typography>
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center" onClick={() => handleBatchClick(index3, b)}>
                {
                    b["sharedTo"] === undefined ? <></> : 
                    b["sharedTo"] == null ? <></> :
                    b["sharedTo"].length > 0 ?
                    <IconButton style={{marginRight: "8px"}} className={globalClasses.customButton} onClick={(e)=>{
                        props.handleBatchShareOpenClick(e, shareObj, b);
                        e.stopPropagation();
                        }}>
                        <People />
                    </IconButton> 
                    : null
                }
            </TableCell>
            <TableCell className={classes.newbatchCell} style={{paddingRight: "8px"}} align="right" onClick={() => handleBatchClick(index3, b)}>
                
                {
                    b["status"] == "Processing" && props.sharedToMe == false 
                    ?
                    <IconButton title={"Cancel"} style={{marginRight: "8px"}} className={globalClasses.customButton} onClick={(e)=>{
                        CancelButton(b);
                        e.stopPropagation();
                    }}>
                        <CancelOutlined />
                    </IconButton>
                    : 
                    <IconButton style={{width: "32px"}} className={globalClasses.customButton}>

                    </IconButton>
                }
                <IconButton className={globalClasses.customButton} onClick={(e)=>{
                    props.handleSetAnchorElBatch(e, b, d["id"], d["revision"], orders, shareObj);
                    e.stopPropagation();
                    }}>
                    <MoreHoriz />
                </IconButton>
            </TableCell>
        </TableRow>
        
        
        <Collapse  unmountOnExit in={selected}>
            <TableContainer style={{ minHeight: "80px", maxHeight: "300px", overflow: "auto", display: "contents"}}>
                <TableRow key={"order_table_" + b["key"]} style={{background:"seashell"}}>
                    <TableCell className={classes.newbatchCell} align="center" colSpan={2}>
                        <Table className={classes.tableres} style={{width:"stretch"}}>
                            <TableRow>
                                <TableCell className={classes.newbatchCell} align="center" style={{fontSize: "smaller", fontWeight: "bold", width: "10%",borderBottom: "0px solid"}}>
                                </TableCell>
                                <TableCell className={classes.newbatchCell} align="left" style={{fontSize: "smaller", fontWeight: "bold", width: "70%",borderBottom: "0px solid", paddingLeft:"15px"}}>
                                {"Test Order"}
                                </TableCell>
                                <TableCell className={classes.newbatchCell} style={{fontSize: "smaller", fontWeight: "bold", borderBottom: "0px solid", width: "20%", paddingRight: "5px"}} align="center">
                                {"Configuration"} 
                                </TableCell>
                            </TableRow>
                        </Table>
                    </TableCell>
                    <TableCell className={classes.newbatchCell} align="center" style={{fontSize: "smaller", fontWeight: "bold", paddingTop: "1%", paddingBottom: "1%"}}>
                        {"Order Status"}
                    </TableCell>
                    <TableCell className={classes.newbatchCell} align="right" colSpan={3} style={{fontSize: "smaller", fontWeight: "bold", paddingTop: "1%", paddingBottom: "1%"}}>
                        {"Error Mode Message"}
                    </TableCell>
                    <TableCell className={classes.newbatchCell} align="right" colSpan={1} style={{paddingRight: "50px", fontSize: "smaller", fontWeight: "bold", paddingTop: "1%", paddingBottom: "1%"}}>
                        {""}
                    </TableCell>
                    <TableCell className={classes.newbatchCell} align="center" colSpan={6}>
                        <TableRow style={{width:"100%", display:"flex"}}>
                            <TableCell className={classes.newbatchCell} align="center" style={{fontSize: "smaller", fontWeight: "bold", width: "50%", borderBottom: "0px solid", paddingTop: "1%", paddingBottom: "1%"}}>
                            {"CAD configuration time"}
                            </TableCell>
                            <TableCell className={classes.newbatchCell} style={{paddingRight: "8px", fontSize: "smaller", fontWeight: "bold", width:"50%", borderBottom: "0px solid", paddingTop: "1%", paddingBottom: "1%"}} align="center">
                            {"CAD re-generation loops"}   
                            </TableCell>
                        </TableRow>
                    </TableCell>
                </TableRow>
                {orderElements == null ? <></> : orderElements}
            </TableContainer>
        </Collapse>
        
        {/* Error Dialog */}
        <Dialog open={errorPopupOpen} onClose={handleCloseErrorPopup} aria-labelledby="error-popup-title">
            <DialogTitle id="error-popup-title">Error</DialogTitle>
            <DialogContent>
            <p>{popupMessage}</p>
                <p>There was an error processing this batch. Please try again.</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseErrorPopup} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
        <Dialog open={circularProgressOpen} id="CirProg">
        <DialogTitle>
            {progress <= 0
                ? "Preparing file..."
                : progress >= 100
                    ? "Finalizing download..."
                    : `Downloading file (${progress}%)`}
        </DialogTitle>

        <div style={{ padding: "20px", width: "300px" }}>
            <LinearProgress
                variant={progress <= 0 || progress >= 100 ? "indeterminate" : "determinate"}
                value={progress}
                style={{ height: "10px", borderRadius: "5px" }}
            />

            <div style={{ textAlign: "center", marginTop: "10px" }}>
                {progress <= 0
                    ? "Please wait..."
                    : progress >= 100
                        ? "Almost done..."
                        : `${progress}%`}
            </div>
        </div>
    </Dialog>
        </React.Fragment>
    );
}